/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Invitation lifecycle state.
 */
export const OrganizationInvitationState = {
  Pending: "pending",
  Accepted: "accepted",
  Expired: "expired",
  Revoked: "revoked",
} as const;
/**
 * Invitation lifecycle state.
 */
export type OrganizationInvitationState = OpenEnum<
  typeof OrganizationInvitationState
>;

export type OrganizationInvitation = {
  /**
   * When the invitation was accepted.
   */
  acceptedAt?: Date | undefined;
  createdAt: Date;
  /**
   * Invitee email address.
   */
  email: string;
  /**
   * When the invitation expires.
   */
  expiresAt?: Date | undefined;
  /**
   * WorkOS invitation ID.
   */
  id: string;
  /**
   * Speakeasy user ID of the inviter, when known.
   */
  inviterUserId?: string | undefined;
  /**
   * When the invitation was revoked.
   */
  revokedAt?: Date | undefined;
  /**
   * WorkOS role slug assigned when the invite is accepted.
   */
  roleSlug?: string | undefined;
  /**
   * Invitation lifecycle state.
   */
  state: OrganizationInvitationState;
  updatedAt: Date;
};

/** @internal */
export const OrganizationInvitationState$inboundSchema: z.ZodMiniType<
  OrganizationInvitationState,
  unknown
> = openEnums.inboundSchema(OrganizationInvitationState);

/** @internal */
export const OrganizationInvitation$inboundSchema: z.ZodMiniType<
  OrganizationInvitation,
  unknown
> = z.pipe(
  z.object({
    accepted_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    email: z.string(),
    expires_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    id: z.string(),
    inviter_user_id: z.optional(z.string()),
    revoked_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    role_slug: z.optional(z.string()),
    state: OrganizationInvitationState$inboundSchema,
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "accepted_at": "acceptedAt",
      "created_at": "createdAt",
      "expires_at": "expiresAt",
      "inviter_user_id": "inviterUserId",
      "revoked_at": "revokedAt",
      "role_slug": "roleSlug",
      "updated_at": "updatedAt",
    });
  }),
);

export function organizationInvitationFromJSON(
  jsonString: string,
): SafeParseResult<OrganizationInvitation, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OrganizationInvitation$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OrganizationInvitation' from JSON`,
  );
}
